<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-Description" *ngIf="!fields.Description.hidden && !fields.Description.removed" 
                            class="field-container full {{fields.Description.invalid ? 'invalid' : ''}} {{fields.Description.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.Description.styles.style"
                            [ngClass]="fields.Description.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.Description.label + (fields.Description.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.Description.label}}<span *ngIf="fields.Description.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <label data-cy="label" class="datex-label"
                                [ngStyle]="fields.Description.control.styles.style"
                                [ngClass]="fields.Description.control.styles.classes"
                                [matTooltip]="fields.Description.control.tooltip"
                                matTooltipClass="datex-control-tooltip">{{fields.Description.control.label}}</label>
                        <ng-container *ngIf="fields.Description.invalid">
                          <ng-container *ngFor="let error of fields.Description.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-contents" *ngIf="!fields.contents.hidden && !fields.contents.removed" 
                            class="field-container full {{fields.contents.invalid ? 'invalid' : ''}} {{fields.contents.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.contents.styles.style"
                            [ngClass]="fields.contents.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.contents.label + (fields.contents.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.contents.label}}<span *ngIf="fields.contents.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="contents"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.contents.control.readOnly || fields.contents.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.contents.control.placeholder}}"
                                [ngStyle]="fields.contents.control.styles.style"
                                [ngClass]="fields.contents.control.styles.classes"
                                [matTooltip]="fields.contents.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.contents.invalid">
                          <ng-container *ngFor="let error of fields.contents.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>